import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AbstractComponent } from '../util/abstract.component';
import { LiquidacaoModalDetalhesComponent } from './liquidacao-modal-detalhes.component';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { SessaoService } from '../services/sessao.service';
import { LiquidacaoAntecipadaService } from '../services/liquidacaoantecipada.service';
import { LiquidacaoModalConfirmarComponent } from './liquidacao-modal-confirmar.component'
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { Contrato } from '../modelo/contrato';
import { Boleto } from '../modelo/boleto';
import { Parcela } from '../modelo/parcela';
import { Config } from '../services/config';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $: any;

@Component({
  selector: 'app-liquidacao-parcelas',
  templateUrl: './liquidacao-parcelas.component.html',
  styleUrls: ['./liquidacao.component.css'],
  providers: [LiquidacaoAntecipadaService, MensagemService, RestClientService]
})
export class LiquidacaoParcelasComponent extends AbstractComponent implements OnInit {

  contrato: Contrato;
  boleto: Boleto;
  lstMensagem: string[];

  constructor(
    private sessaoService: SessaoService,
    private liquidacaoAntecipadaService: LiquidacaoAntecipadaService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  ngOnInit() {
    //Scroll top
    window.scrollTo(0, 0);
    this.contrato = JSON.parse(sessionStorage.getItem('liquidacaoContrato'));
    this.contrato.qtParcelasAbertas = 0; // não selecionado
    this.contrato.cdOrdemParcelasAbertas = ''; // não selecionado
    this.lstMensagem = this.contrato.lstMensagem;

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
    
  }

  modalDetalhar(): void {
    this.dialog.open(LiquidacaoModalDetalhesComponent, {
      width: Config.POPUP_100VW,
      height: Config.POPUP_100FULL,
      data: {
        contrato: this.contrato
      }
    });
  }

  onClickConfirmar(): void {
    if (!this.validacaoBasica()) {
      this.mensagemService.show(this.campos);
      $('html, body').animate({
        scrollTop: $("#formaPagamentoTitle").offset().top
      }, 1000);
      return;
    }
    this.liquidacaoAntecipadaService.confirmarParcela(this.contrato).subscribe(
      (result: Contrato) => {
        result.tpContrato = this.contrato.tpContrato
        if (result.cdMsgemRetorno == "0") {
          this.dialog.open(LiquidacaoModalConfirmarComponent, {
            width: Config.POPUP_100VW,
            height: Config.POPUP_100FULL,
            data: {
              contrato: result
            }
          });
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  validacaoBasica = (): boolean => {
    this.mensagemService.clear();
    this.campos = [];
    var isValid = true;
    if (!this.contrato.qtParcelasAbertas || this.contrato.qtParcelasAbertas == 0) {
      this.campos.push("qtParcelasAbertas");
      isValid = false;
    }
    if (!this.contrato.cdOrdemParcelasAbertas || this.contrato.cdOrdemParcelasAbertas == "") {
      this.campos.push("cdOrdemParcelasAbertas");
      isValid = false;
    }
    return isValid;
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-liquidacao-cli/liquidacao-parcelas.component.ts